// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__e2L_0","hide":"styles_hide__F11_7"};